import React, { useState } from "react"
import  "../AnbarGardaniStyle.css";
import * as Constants from '../../../constants/urls';

const LostProductModal=(props)=>{
    
    return(
        <React.Fragment>
          
<div className="location_modal text-right">
<div className="location_modal_box">
    <div className="location_modal_header bg-dark p-2">
<span className=" w-100 text-right text-white">اخطار</span>
    </div>
    <div className="p-4 text-center">
<p>
    محصولات زیر در این لوکیشن موجودی دارند اما لاگ انبارگردانی برای آن ها ثبت نشده است 
</p> 
<p>
با تایید مقدار صفر برای آنها ثبت میشود</p> 
<div className="lostProductBox container">
{
             props.lostProducts!=undefined &&    props.lostProducts!=null && props.lostProducts.map((item, index) => {return(
                <div className="row my-1 p-1" style={{background:"#00000008"}}>
<div className="col-sm-3 col-4 mt-3 mt-md-0">
<img src={Constants.imagesBsaeUrl+'/image/resizeTest/shop/_1000x/thumb_' + item.product.prodID + '.jpg'} style={{width: '100%', height: '100%', borderRadius: '2px' ,cursor:"pointer"}} />
</div>

<div className="col-sm-9 col-8 mt-3 mt-md-0" style={{fontSize:"12px", fontWeight:"bold"}}>
<p className="p-0 m-0 my-sm-2">{item.product.prodName_fa}</p>
<p className="p-0 m-0 my-sm-2">{item.label}</p>
 <p className="p-0 m-0 my-sm-2">بارکد بسته : {item.barCode}  </p>
</div> 

 </div>
 
                ) 
            })
        } 
</div>
<hr />
<div className="row text-right my-3 " style={{direction:"rtl"}}>
    <div className="col-6 text-left">
    <button className="btn btn-success w-50" onClick={props.apply}>تایید</button>
    </div>
    <div className="col-6  text-right">

    <button className="btn btn-danger w-50" onClick={props.close}>انصراف</button>
    </div>
    </div>
    </div>
   

</div> 
</div> 
            </React.Fragment>
        )
}
export default LostProductModal;